export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فتح نزاع"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سينضم مشرف للمساعدة. يرجى اختيار السبب وإرفاق الأدلة."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال إلى المشرف"])}
}